import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { STAGES, TERMINAL } from "@/lib/format";

export function StageStepper({ status }: { status: string }) {
  const idx = STAGES.findIndex((s) => s.value === status);
  const terminal = TERMINAL.find((t) => t.value === status);
  return (
    <div className="overflow-x-auto" data-testid="stage-stepper">
      <ol className="flex min-w-[760px] items-center">
        {STAGES.map((s, i) => {
          const done = idx >= 0 && i < idx;
          const current = i === idx;
          return (
            <li key={s.value} className="flex flex-1 items-center" data-testid={`stage-${s.value}`}>
              <div className="flex flex-col items-center gap-2 text-center">
                <span className={cn("grid h-9 w-9 place-items-center rounded-full border text-[14px]",
                  done && "border-gold bg-gold text-ink", current && "border-orchid bg-plum text-mist", !done && !current && "border-gold/30 text-mist/60")}>
                  {done ? <Check size={16} /> : i + 1}
                </span>
                <span className={cn("text-[14px]", current ? "text-mist" : "text-mist/65")}>{s.label}</span>
              </div>
              {i < STAGES.length - 1 && <span className={cn("mx-2 mb-7 h-px flex-1", done ? "bg-gold" : "bg-gold/25")} />}
            </li>
          );
        })}
      </ol>
      {terminal && <p className="mt-3 text-[15px] text-red-200" data-testid="stage-terminal">Closed as {terminal.label}</p>}
    </div>
  );
}
